<template>
    <rkm-modal
        :loading="loading"
        :title="`Materiais (${grupo.nome})`"
        large
        persistent
        ref="Modal"
    >
        <rkm-table
            :fields="fields"
            :items="materiais"
            @filtered="materiaisFiltered = $event"
            class="table-materiais"
        >
            <template #head(permiteRequisitar)="">
                <rkm-form-checkbox
                    :indeterminate="indeterminate"
                    :value="true"
                    @change="selectAll"
                    v-model="selectedAll"
                />
            </template>

            <template v-slot:cell(permiteRequisitar)="{ item }">
                <rkm-form-checkbox
                    :value="true"
                    @change="!$event && (item.estoqueMaximo = null)"
                    v-model="item.permiteRequisitar"
                />
            </template>

            <template v-slot:cell(estoqueMaximo)="{ item }">
                <rkm-form-input
                    :disabled="!item.permiteRequisitar"
                    :validations="validations.estoqueMaximo"
                    class="my-auto estoque-maximo"
                    name="Estoque máximo"
                    number
                    v-model="item.estoqueMaximo"
                />
            </template>
        </rkm-table>

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapGetters } from 'vuex'

// Others.
import { object } from '@/mixins'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                {
                    key: 'permiteRequisitar',
                    class: 'col-min text-center'
                },
                {
                    key: 'codigo',
                    label: 'Código',
                    sortable: true,
                    class: 'col-min'
                },
                {
                    key: 'descricaoCompleta',
                    label: 'Descrição',
                    sortable: true,
                },
                {
                    key: 'subgrupoNome',
                    label: 'Subgrupo',
                    sortable: true,
                },
                {
                    key: 'estoqueMaximo',
                    label: 'Estoque máximo',
                    class: 'col-min'
                },
            ]
        },
        validations() {

            return {
                estoqueMaximo: {
                    max: 8,
                    max_value: 99999999,
                }
            }
        }
    },
    data: () => ({
        grupo: {},
        materiais: [],
        materiaisFiltered: [],
        indeterminate: false,
        selectedAll: false,
    }),
    methods: {
        open(grupo) {

            this.grupo = grupo
            this.materiais = this.clone(grupo.materiais)
            this.materiaisFiltered = this.clone(this.materiais)

            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        selectAll(permitido) {

            this.materiais
                .filter(m => this.materiaisFiltered.find(mf => mf.id === m.id))
                .map(m => m.permiteRequisitar = permitido)
        },
        save() {

            this.grupo.permiteRequisitar = !!this.materiais.find(m => m.permiteRequisitar)
            this.grupo.materiais = this.clone(this.materiais)

            this.$refs.Modal.hide()
        },
        handleSelectAllStatus() {

            this.indeterminate = false

            const materiaisFiltered = this.materiais
                .filter(sg => this.materiaisFiltered.find(sgf => sgf.id === sg.id))

            const quantidadePermitida = materiaisFiltered.filter(sg => sg.permiteRequisitar).length

            this.selectedAll = quantidadePermitida > 0 && quantidadePermitida == materiaisFiltered.length

            if (quantidadePermitida > 0 && quantidadePermitida != materiaisFiltered.length) {

                this.indeterminate = true
            }
        }
    },
    mixins: [object],
    watch: {
        materiais: {
            deep: true,
            handler() {

                this.handleSelectAllStatus()
            }
        },
        materiaisFiltered() {

            this.handleSelectAllStatus()
        }
    }
}
</script>

<style scoped>
.table-materiais >>> .estoque-maximo { min-width: 120px; }
</style>